module.exports = __webpack_public_path__ + "img/simon_zsuzsi_c80_A3-05.ab489f7d.jpg";